import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBXyWbUW6nxvnXLThtugeJSfS6qA_KGG9U',
  // The value of `databaseURL` depends on the location of the database
  databaseURL: 'https://civicore.firebaseio.com',
  projectId: 'firebase-civicore',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
